function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { _query, isHttpWithData } from "noood/net/xhr";
import Widget from "noood/comp/widget/Widget";
import Text from "noood/comp/text/Text";
import Skeleton from "noood/comp/skeleton/Skeleton";
export default function CountWidget(props) {
  var entity = props.entity,
    predicate = props.predicate,
    caption = props.caption,
    initialWidth = props.initialWidth,
    to = props.to;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    count = _useState2[0],
    setCount = _useState2[1];
  useEffect(function () {
    if (props.entity) {
      _query("/w-count", {
        entity: entity,
        predicate: predicate
      }, function (res) {
        if (isHttpWithData(res)) {
          setCount(res.data);
        } else {
          setCount(null);
        }
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(Widget, {
    caption: caption,
    initialWidth: initialWidth,
    to: to
  }, /*#__PURE__*/React.createElement(React.Fragment, null, count === void 0 && /*#__PURE__*/React.createElement(Skeleton, {
    height: 44,
    width: 50
  }), count === null && /*#__PURE__*/React.createElement(React.Fragment, null), !isNaN(count) && /*#__PURE__*/React.createElement(Text, {
    size: 40
  }, count)));
}

// @ts-ignore